import initExamsSlider from "./init-exams-slider";

const sliders = () => {
    initExamsSlider();
};

export default sliders;
